import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaPhoneAlt,
  FaGlobe,
  FaEnvelope,
} from "react-icons/fa";
import logo from "../../assets/Pasted image.png";

import "./footer.css";

const Footer = () => {
  return (
    <footer
      className="footer text-white pt-5 pb-3"
      style={{ overflow: "hidden" }}
    >
      <Container>
        <Row className="gy-4">
          <Col md={4} data-aos="fade-right">
            <a
              className="navbar-brand d-flex align-items-center footer-logo mb-4"
              href="#"
            >
              <img src={logo} alt="Logo" className="logo" />
              <span className="ms-2">EHSAS</span>
            </a>

            <p>
              EHSAS is your one-stop solution for simplified maintenance and
              service packages.
            </p>
            <div className="footer-contact mt-3">
              <p className="mb-2">
                <FaPhoneAlt className="me-2 fs-5" />
                <a
                  href="tel:+911234567890"
                  className="text-white text-decoration-none"
                >
                  +91-903-333-5354
                </a>
              </p>
              <p className="mb-2">
                <FaEnvelope className="me-2 fs-5" />
                <a
                  href="mailto:support@ezymps.com"
                  className="text-white text-decoration-none"
                >
                  info@ehsas.life
                </a>
              </p>
              <p>
                <FaGlobe className="me-2 fs-5" />
                <a
                  href="https://ehsas.life/"
                  className="text-white text-decoration-none"
                  target="_blank"
                  rel="noreferrer"
                >
                  www.ehsas.com
                </a>
              </p>
            </div>
          </Col>
          <Col md={4} data-aos="fade-down">
            <h5 className="footer-heading">Useful Links</h5>
            <ul className="footer-links list-unstyled">
              <li>
                <a href="#">Home</a>
              </li>
              <li>
                <a href="#">Services</a>
              </li>
              <li>
                <a href="#">Contact</a>
              </li>
              <li>
                <a href="#">Support</a>
              </li>
            </ul>
          </Col>
          <Col md={4} data-aos="fade-left">
            <h5 className="footer-heading">Follow Us</h5>
            <div className="footer-social d-flex gap-3 ">
              <a href="#">
                <FaFacebookF />
              </a>
              <a href="#">
                <FaInstagram />
              </a>
              <a href="#">
                <FaTwitter />
              </a>
              <a href="#">
                <FaLinkedinIn />
              </a>
              <a href="#">
                <FaYoutube />
              </a>
            </div>
          </Col>
        </Row>
        <hr className="my-4 border-light " />
        <Row>
          <Col className="text-center">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} EHSAS. All rights reserved
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
